import React from "react";

import { DashboardPageBody } from "../../components/Page";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import ProfilesPage from "./ui";

const Profiles = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <DashboardPageBody>
        <ProfilesPage />
      </DashboardPageBody>
    </DashboardLayout>
  );
};

export default Profiles;
